import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { clearToken } from '../utils/tokenHelper';
import StartImage from '../images/Ai Icon.png'
import Logo from "../images/logo/Quick-Care.png";
import { AiFillHome } from "react-icons/ai";
import { IoChatbubbles } from "react-icons/io5";
import { IoSettings } from "react-icons/io5";
import { MdLogout } from "react-icons/md";
// Add a money-related icon for the withdrawal feature
import { MdAccountBalanceWallet } from "react-icons/md";
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import { FaUserDoctor } from "react-icons/fa6";


const Sidebar = ({ toggleSidebar, isSidebarOpen }) => {
    const location = useLocation(); 
    const navigate = useNavigate();

    const handleLogout = () => { 
        clearToken();
        navigate('/login');
    };

    return (
        <div className='flex flex-col h-screen justify-between items-start p-3 py-3 lg:py-6 border border-[#E9EBE9]
          bg-white z-50 instrument-sans-semibold w-full lg:w-auto'>
            <div className='w-full flex items-center justify-between'>
                <div className='h-1/6'>
                    <Link to='/' className='block lg:hidden' onClick={toggleSidebar}>
                        <img src={Logo} alt="Logo" className='w-32 h-15'/>
                    </Link>
                </div>

                <div className='lg:hidden mt-6' onClick={toggleSidebar}>
                    {isSidebarOpen ? <MenuIcon /> : <ClearIcon /> }
                </div>
            </div>
            <div className='h-1/6'>
                <Link to='/' className='hidden lg:block' onClick={toggleSidebar}>
                    <img src={Logo} alt="Logo" className='w-32 h-15'/>
                </Link>
            </div>

            <div className='flex flex-col gap-4 w-full h-5/6'>
                <Link 
                    to="/trivia-games" 
                    className='flex gap-1.5 rounded-lg items-center justify-center px-3 py-2.5 text-white bg-gradient-to-b from-[#069125] to-[#6AEF88]'
                    onClick={toggleSidebar}
                >
                    <img src={StartImage} alt="" className='w-[16px] h-[16px]'/>
                    <span>Play Quickcare Quiz</span>
                </Link>

                <h1 className='text-[#828282] font-semibold text-sm'>
                    Dashboard
                </h1>

                <Link 
                    className={`flex gap-1 items-center w-full p-2 rounded-lg hover:bg-[#CDE9D3] hover:text-[#069125] font-semibold
                    ${location.pathname === '/' ? 'bg-[#E6FCEA] text-[#069125] font-semibold' : 'text-[#828282]'}`} 
                    to="/"
                    onClick={toggleSidebar}
                >
                    <AiFillHome />
                    <span>Home</span>
                </Link>

                <Link 
                    className={`flex gap-1 items-center w-full p-2 rounded-lg hover:bg-[#CDE9D3] hover:text-[#069125] font-semibold
                    ${location.pathname === '/health' ? 'bg-[#E6FCEA] text-[#069125] font-semibold' : 'text-[#828282]'}`} 
                    to="/health"
                    onClick={toggleSidebar}
                >
                    <FaUserDoctor />
                    <span>Consult Doctor</span>
                </Link>

                <Link 
                    className={`flex gap-1 items-center w-full p-2 rounded-lg hover:bg-[#CDE9D3] hover:text-[#069125] font-semibold
                    ${location.pathname === '/history' ? 'bg-[#E6FCEA] text-[#069125] font-semibold' : 'text-[#828282]'}`} 
                    to="/history"
                    onClick={toggleSidebar}
                >
                    <IoChatbubbles />
                    <span>Consultation History</span>
                </Link>
            </div>

            <div className='flex flex-col gap-6 w-full'>
                {/* Added Withdrawal Link */}
                <Link 
                    className={`flex gap-1 items-center w-full p-2 rounded-lg hover:bg-[#CDE9D3] hover:text-[#069125] font-semibold
                    ${location.pathname === '/withdraw' ? 'bg-[#E6FCEA] text-[#069125] font-semibold' : 'text-[#828282]'}`} 
                    to="/withdraw"
                    onClick={toggleSidebar}
                >
                    <MdAccountBalanceWallet />
                    <span>Withdraw</span>
                </Link>
                
                <Link 
                    className={`flex gap-1 items-center w-full p-2 rounded-lg hover:bg-[#CDE9D3] hover:text-[#069125] font-semibold
                    ${location.pathname === '/settings' ? 'bg-[#E6FCEA] text-[#069125] font-semibold' : 'text-[#828282]'}`} 
                    to="/settings"
                    onClick={toggleSidebar}
                >
                    <IoSettings />
                    <span>Settings</span>
                </Link>

                <button
                    className='flex gap-1 items-center w-full p-2 rounded-lg text-[#E12C2C] hover:font-semibold'
                    onClick={handleLogout}
                >
                    <MdLogout />
                    <span>Logout</span>
                </button>
            </div>
        </div>
    );
};

export default Sidebar;